<template>
  <alternative-list
    :partId="partId"
    :gridId="gridId"/>
</template>

<script>

import { GRID_ID } from '@/shared/constants';
import AlternativeList from '@/shared/components/Alternatives';

export default {
  computed: {
    partId(){
      return this.$route.params.partId;
    },
  },
  data: () => ({
    gridId: GRID_ID.PART_DETAILS_ALTERNATIVES,
  }),
  components: {
    AlternativeList,
  },
};
</script>
